import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import AccessPointButton from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointButton';
import AccessPointModal from 'components/FrictionlessCheckout/DeliverToReleaseThree/AccessPoint/AccessPointModal';
import orderUtils from 'utils/Order';

export const AccessPoint = ({
    accessPointCallback,
    accessPointAddress,
    localization,
    isHal,
    full,
    fullTitle,
    holdAtLocation,
    infoModalTitle,
    showMediaModal,
    globalModals,
    moreInfoLabel,
    fireInfoModalAnalytics,
    addressId,
    isRadio,
    isEdit
}) => {
    const [showAccessPointModal, setShowAccessPointModal] = useState(false);

    const toggleShowAccesPointModal = () => {
        setShowAccessPointModal(prevState => !prevState);
    };

    const setAccessPoint = accessPoint => {
        const address = {
            addressType: orderUtils.SHIPPING_METHOD_TYPES.HAL,
            address1: accessPoint?.addressLine1,
            city: accessPoint?.city,
            state: accessPoint?.state,
            postalCode: accessPoint?.zipCode,
            country: accessPoint?.country,
            altPickLocationID: accessPoint?.locationId,
            altPickLocationType: accessPoint?.pickupLocationType,
            altPickLocationPartner: accessPoint?.carrierFixed,
            altLocationPhone: accessPoint?.phoneNumber,
            halCompany: accessPoint?.companyName
        };

        const halOperatingHours = accessPoint?.operatingHours;
        accessPointCallback(true, isEdit, { ...address, halOperatingHours });
    };

    const label = !isHal ? (!full ? holdAtLocation : localization.selectLocationNearYou) : localization.selectLocationNearYou;

    return (
        <>
            {showAccessPointModal && (
                <AccessPointModal
                    isOpen={showAccessPointModal}
                    onDismiss={toggleShowAccesPointModal}
                    callback={setAccessPoint}
                />
            )}
            <AccessPointButton
                label={label}
                accessPointHandler={toggleShowAccesPointModal}
                infoModalTitle={infoModalTitle}
                showMediaModal={showMediaModal}
                globalModalsProp={globalModals}
                moreInfoLabel={moreInfoLabel}
                fireInfoModalAnalytics={fireInfoModalAnalytics}
                addressId={addressId}
                isHal={isHal}
                accessPointAddress={accessPointAddress}
                {...(accessPointAddress && { accessPointCallback })}
                {...(full && { title: !isRadio ? holdAtLocation : fullTitle, isRadio: isRadio })}
            />
        </>
    );
};

export default wrapFunctionalComponent(AccessPoint, 'AccessPoint');
